import React, { FC } from 'react';
import Preview from './assets/images/preview.webp';
import PreviewRetina from './assets/images/preview-retina.webp';
import AboutUsStructuredData from './components/about-us-structured-data';
import PageSectionBox from 'components/pages/page-section-box/page-section-box';

import './index.base.scss';
import SrcSizes from 'modules/shared/components/src-sizes/src-sizes';

const AboutUsBase: FC = () => (
    <section className="about-us">
        <SrcSizes
            className="about-us__image"
            alt="Podgląd"
            width={1392}
            height={400}
            image={Preview}
            imageSizes={[{
                image: Preview,
                width: 1392
            }, {
                image: PreviewRetina,
                width: 1670
            }]}
        />
        <PageSectionBox
            headerText="O nas – Cenojad.pl"
            padding="lg"
        >
            <div className="about-us__container">
                <h2>Zostań smakoszem oszczędności i zjadaj ceny z Cenojadem!</h2>
                <p>
                    Cenojad.pl to wiarygodny i wszechstronny przegląd ofert tysięcy sklepów internetowych. Jego
                    nieograniczony apetyt sprawia, że w aktualizowanym codziennie katalogu znajdziesz dosłownie
                    miliony produktów. Oczywiście zawsze w najlepszej cenie.
                </p>
                <p>
                    W naszym menu oferujemy obfity katalog produktów, wyszukiwanie proste jak bułka z masłem, a
                    na deser: smakowite porównywanie cen. Smacznego!
                </p>
                <h2>
                    Cenojad.pl to smakowita propozycja dla konsumentów, którzy lubią proste, opłacalne i sycące zakupy:
                </h2>
                <ul>
                    <li>
                        <h3>Bogaty katalog produktów</h3>
                        <p>
                            Pozwalamy użytkownikom na znajdywanie najbardziej dopasowanych do swoich potrzeb ofert
                            z setek rozmaitych kategorii.
                        </p>
                    </li>
                    <li>
                        <h3>Porównywanie ofert oraz cen</h3>
                        <p>
                            Dzięki oferowanej przez nas możliwości porównywania cen na stronach produktów użytkownicy mają
                            możliwość wyboru najkorzystniejszych ofert spośród wielu sklepów.
                        </p>
                    </li>
                    <li>
                        <h3>Przejrzysta strona główna</h3>
                        <p>
                            U nas znajdziesz zawsze tylko to, co najważniejsze – dlatego maksymalnie czytelna
                            strona główna Cenojad.pl zawsze wypełniona jest atrakcyjnymi ofertami.
                        </p>
                    </li>
                </ul>
                <h2>Cenojad.pl jest częścią Ringier Axel Springer Polska</h2>
                <p>
                    Ringier Axel Springer Polska to właściciel Onet.pl, jednego z największych polskich portali internetowych,
                    a także wielu innych marek – np.: Fakt, Newsweek, Business Insider, Skąpiec.pl, Lamoda.pl.
                </p>
                <h2>Lokalizacja</h2>
                <p>
                    Ringier Axel Springer Polska sp. z o.o.<br />
                    ul. Domaniewska 49<br />
                    02–672 Warszawa<br />
                    tel.
                    {' '}
                    <a
                        href="tel:22-232-0000"
                    >
                        22 232 0000
                    </a>
                </p>
            </div>
        </PageSectionBox>
        <AboutUsStructuredData />
    </section>
);

export default AboutUsBase;
